import React from 'react';

interface AppHeaderProps {
  onQuitClick?: () => void;
}

const AppHeader: React.FC<AppHeaderProps> = ({ onQuitClick }) => {
  return (
    <header className="min-h-20 bg-transparent relative z-10 flex items-start justify-between px-8 pt-6">
      <img
        src="/images/mic-logo-white.png"
        alt="MIC Logo"
        style={{ maxWidth: "250px" }}
      />
      {onQuitClick && (
        <button
          onClick={onQuitClick}
          style={{
            color: 'rgba(245, 245, 245, 0.50)',
            textAlign: 'center',
            fontFamily: 'Interstate',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '20px',
            padding: '4px 8px',
            borderRadius: '50px',
            background: 'rgba(255, 255, 255, 0.05)',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          Quit Interview
        </button>
      )}
    </header>
  );
};

export default AppHeader;
